import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { EmptyState } from "../components/ui";
import { trackEvent } from "../lib/analytics";

export default function Custom404Page() {
  const location = useLocation();

  useEffect(() => {
    trackEvent("not_found_viewed", { path: location.pathname });
  }, [location.pathname]);

  return (
    <div data-testid="not-found-page" className="py-8">
      <EmptyState
        title="Page not found"
        subtitle="This route does not exist. You can continue from home, open pantry, or contact support."
        action={
          <div className="flex flex-wrap gap-2">
            <Link to="/app/home" className="pr-btn-primary inline-flex min-h-10 items-center px-4 text-sm font-semibold" onClick={() => trackEvent("not_found_recovery_clicked", { destination: "home" })}>
              Go home
            </Link>
            <Link to="/app/pantry" className="pr-btn-secondary inline-flex min-h-10 items-center px-4 text-sm font-semibold" onClick={() => trackEvent("not_found_recovery_clicked", { destination: "pantry" })}>
              Open pantry
            </Link>
            <a href="/contact/" className="pr-btn-secondary inline-flex min-h-10 items-center px-4 text-sm font-semibold" onClick={() => trackEvent("not_found_recovery_clicked", { destination: "contact" })}>
              Contact support
            </a>
          </div>
        }
      />
    </div>
  );
}
